import KunLoading67 from './src/index'

KunLoading67.install = function (Vue) {
	Vue.component(KunLoading67.name, KunLoading67);
}

export default KunLoading67;
